import Cookies from './cookies-policy'
import Privacy from './privacy-policy'
import TermsAndConditions from './terms'

export default {
    Cookies,
    Privacy,
    TermsAndConditions,
}
